<template>
  <div>
    <div v-if="isLoadingFields">
      <div class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t("geral.loadingData") }}</strong>
      </div>
    </div>
    <div v-else>
      <h1>{{ rawQuery.title }}</h1>
      <b-table
        ref="table"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("geral.loadingData") }}</strong>
          </div>
        </template>
        <template v-slot:cell(TABLE_ROWACTION)="row">
          <div class="buttons">
            <!-- {{ data }} -->
            <a :href="row.value">
              <b-button size="sm">{{ row.field.label }}</b-button>
            </a>
          </div>
        </template>
        <template v-slot:head(TABLE_ROWACTION)>
          <div></div>
        </template>
      </b-table>
    </div>
    <!-- <pre class="language-json"><code>rawQuery: {{ rawQuery  }}</code></pre> -->
  </div>
</template>
  <script>
export default {
  name: "WorkflowFilled",
  props: {
    processId: String,
  },
  components: {},
  data() {
    return {
      isBusy: false,
      isLoadingFields: true,
      tableFilters: {
        fields: [],
      },
      fields: [],
      rawQuery: {
        title: "",
        integrationName: "",
        sql: "",
      },
      tableRowCount: 0,
    };
  },
  created() {
    this.getRawQuery();
  },
  computed: {},
  methods: {
    refreshTable() {
      this.$refs.table.refresh();
    },
    myProvider(ctx, callback) {
      if (this.isLoadingFields) {
        this.isBusy = false;
        this.tableRowCount = 0;
        return [];
      }
      this.isBusy = true;
      let items = [];
      let apiParam = {
        integrationName: this.rawQuery.integrationName,
        sql: this.rawQuery.sql,
      };
      this.$apiDynamicSearches
        .post("/rawQueryResult/", apiParam)
        .then((response) => {
          items = response.data;
          let r = [];
          items.forEach((item) => {
            r.push(item.labels);
          });
          this.tableRowCount = r.length;
          callback(r);
        });
    },
    getRawQuery() {
      this.$apiDynamicSearches
        .get("/rawQuery/" + this.processId)
        .then((response) => {
          if (response.data != "") {
            this.rawQuery = response.data;
            this.fields = response.data.fields;
          }
          this.isLoadingFields = false;
          this.refreshTable();
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            if (error.response.data) {
              console.log(error.response.data.errors);
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
          }
          this.isLoadingFields = false;
          this.refreshTable();
        });
    },
  },
  watch: {
    processId() {
      this.tableFilters.fields = [];
      this.fields = [];
      this.getRawQuery();
    },
  },
};
</script>
  <style scoped>
.table-width {
  min-width: 600px;
}
.link {
  text-decoration: underline;
  color: white !important;
}
.link2 {
  text-decoration: underline;
}
</style>